<template>
  <section
    class="container mx-auto py-6 md:py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-6 md:gap-y-10"
  >
    <template v-if="isLoading">
      <div v-for="i in 6" :key="i" class="flex">
        <UtilsSkeletonLoading class="w-6 h-7" />
        <div class="ml-4 flex-1">
          <UtilsSkeletonLoading class="w-full mb-2 h-7" />
          <UtilsSkeletonLoading class="w-full h-24" />
        </div>
      </div>
    </template>
    <template v-else>
      <NuxtLink
        v-for="(industry, index) in industryData"
        :key="index"
        :to="`/industries/${industry.attributes?.slug}`"
        :title="industry.attributes?.title"
        class="flex flex-col gap-3 industry-card p-4 border-b-2 border-transparent hover:border-b-2 hover:border-primary-primary"
      >
        <div class="industry-title flex gap-4 items-center">
          <NuxtImg
            format="webp"
            srcset=""
            loading="lazy"
            class="w-8 h-8 icon"
            :src="industry.attributes?.icon?.data?.attributes?.url || '/'"
            :alt="industry.attributes?.title"
            :title="industry.attributes?.title"
          />
          <h3 class="text-lg text-bw-900 title">
            {{ industry.attributes?.title }}
          </h3>
          <NuxtIcon name="chevron-right" />
        </div>
        <div class="industry-desc">
          <p class="text-base text-bw-900">
            {{ industry.attributes?.description }}
          </p>
        </div>
      </NuxtLink>
    </template>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const industryData = ref([])

const getIndustriesList = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    '/api/industries',
    {
      query: {
        'populate[icon][fields][0]': 'url',
        'fields[0]': 'id',
        'fields[1]': 'title',
        'fields[2]': 'description',
        'fields[3]': 'slug',
        'sort[0]': 'title:asc'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Industries does not exist`
    })
  }

  return data.value
}

const industries = await getIndustriesList()
industryData.value = industries.data
</script>

<style lang="scss" scoped>
.industry-card {
  .industry-title {
    font-weight: 500;
  }

  &:hover {
    box-shadow: 0px 2px 10px 0px #0000001a;

    .industry-title {
      .title {
        color: #ff6700;
      }

      .icon {
        filter: invert(49%) sepia(56%) saturate(4532%) hue-rotate(0deg)
          brightness(103%) contrast(106%);
      }
    }

    :deep(.nuxt-icon) {
      svg {
        path {
          fill: #ff6700 !important;
        }
      }
    }
  }
}

:deep(.automotive-icon) {
  svg {
    width: 32px;
    height: 32px;
  }
}
</style>
